export const isEmptyFilterValue = value => {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  return value === undefined || value === null || value === '';
};

export const serializeTableFilterValue = value => {
  if (Array.isArray(value)) {
    return value.join(',');
  }
  return value;
};

export const serializeTableFilters = (filters = {}) =>
  Object.keys(filters).reduce((result, filterName) => {
    const value = filters[filterName];
    if (isEmptyFilterValue(value)) {
      return result;
    }
    return {
      ...result,
      [filterName]: serializeTableFilterValue(value),
    };
  }, {});

export const toggleFilterArrayValue = (values = [], value) => {
  const normalizedValues = Array.isArray(values) ? values : [];
  return normalizedValues.includes(value)
    ? normalizedValues.filter(item => item !== value)
    : [...normalizedValues, value];
};
